import React, { useState } from "react";
import { serverUrl } from "../../setup";
import useUserContext from "../../hooks/useUserContext";

const Insta = ({ setQuiz }) => {
  const [q1, setQ1] = useState("");
  const { user } = useUserContext();
  const [error, setError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (q1) {
      const data = { answer: `${q1}` };
      try {
        const response = await fetch(serverUrl + "/question/8", {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        });
        const json = await response.json();
        if (json.Correct) {
          setQuiz("prison");
        } else {
          setError(true);
        }
      } catch (e) {
        console.log(e);
      }
    }
  };
  return (
    <div className="font-medium text-lg text-white">
      <h1 className="my-2 text-justify">
        As the adventurers gaze upon the celestial canvas, they realize that the
        answer lies not just in the stars, but in the language of the universe
        itself. Guided by the principles of mathematics and the harmony of
        celestial mechanics, they begin to unravel the cosmic code. Each number
        and symbol takes on new meaning as they decode the intricate dance of
        the cosmos, revealing a sequence that transcends time and space.
        <br />
        <em>
          "The key to unraveling the mystery hidden within the paragraph lies
          within the amalgamation of the even-numbered clues"
        </em>
      </h1>
      <form
        action=""
        className="text-left flex flex-col justify-start items-center"
        onSubmit={handleSubmit}
      >
        <input
          type="text"
          className="w-full text-black/70 mt-2 placeholder:text-base rounded-lg mb-2 px-2 py-1"
          placeholder="Enter answer"
          name="1"
          value={q1}
          onChange={(e) => {
            setQ1(e.target.value);
          }}
        />
        {error && <h1 className="text-red-500">Incorrect answer</h1>}
        <button
          type="submit"
          className="border-2 border-white p-2 m-2 rounded-lg w-[50%] "
        >
          Submit
        </button>
      </form>
      <div className="Hint flex justify-center">
      <h1>hint of digital world lies on the insta id Escrowtechtrail</h1>
    </div>
    </div>
  );
};

export default Insta;
